import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("asylum_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("asylum_token");
      setUser(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("asylum_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);
  const signup = useCallback(async (email, password, display_name) => {
    const { data } = await api.post("/auth/signup", { email, password, display_name });
    localStorage.setItem("asylum_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);
  const logout = useCallback(() => { localStorage.removeItem("asylum_token"); setUser(null); }, []);

  const value = useMemo(() => ({ user, loading, login, signup, logout, refresh }), [user, loading, login, signup, logout, refresh]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
